import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/circleci/repo/node_modules/gatsby-theme-docz/src/base/Layout.js";
import { Playground, Props } from 'docz';
import { SelectOrdinal } from './selectordinal';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h1 {...{
      "id": "selectordinal"
    }}>{`SelectOrdinal`}</h1>
    <p>{`Ordinal numbers are a type of number that denotes order.
For example `}<inlineCode parentName="p">{`First I ate dinner.`}</inlineCode>{` But if that number is dynamic and maybe relies on a noun,
then the cases get much more complicated. Fortunately, Stele makes it easy for us to do this.`}</p>
    <h2 {...{
      "id": "basic-usage"
    }}>{`Basic Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`import * as React from 'react'
import { SelectOrdinal } from '@patreon/stele'

function MyComponent(props) {
    return (
        <Text intl>
            Rent is due on the
            <SelectOrdinal
                value={props.dayNum}
                one="#st"
                two="#nd"
                few="#rd"
                other="#th"
            />
        </Text>
    )
}
`}</code></pre>
    <h2 {...{
      "id": "example-message"
    }}>{`Example message`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`{dayNum, selectordinal,
    one {#st}
    two {#nd}
    few {#rd}
    other {#th}
}
`}</code></pre>
    <h2 {...{
      "id": "props"
    }}>{`Props`}</h2>
    <Props of={SelectOrdinal} mdxType="Props" />
    <h2 {...{
      "id": "playground"
    }}>{`Playground`}</h2>
    <Playground __position={1} __code={'() => {\n  const [count, setCount] = React.useState(1)\n  return (\n    <>\n      <div>\n        <input\n          min={1}\n          max={31}\n          value={count}\n          onChange={e => setCount(e.target.value)}\n          type=\"number\"\n        />\n      </div>\n      Rent is due on the\n      <SelectOrdinal\n        value={count}\n        one=\"#st\"\n        two=\"#nd\"\n        few=\"#rd\"\n        other=\"#th\"\n      />\n    </>\n  )\n}'} __scope={{
      props,
      DefaultLayout,
      Playground,
      Props,
      SelectOrdinal
    }} mdxType="Playground">
    {() => {
        const [count, setCount] = React.useState(1);
        return <>
                <div>
                    <input min={1} max={31} value={count} onChange={e => setCount(e.target.value)} type="number" />
                </div>
                Rent is due on the
                <SelectOrdinal value={count} one="#st" two="#nd" few="#rd" other="#th" mdxType="SelectOrdinal" />
            </>;
      }}
    </Playground>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      